module.exports = __webpack_public_path__ + "img/card-tecnologia.f4ba8ead.svg";